import request from '@/utils/request';

export function getServiceList(data) {
  return request.post('/service/list', data);
}

export function ClientList(data) {
  return request.post('/client-employee/wx-list', data);
}

export function ServiceDict(data) {
  return request.post('/service/dict', data);
}



// WEBPACK FOOTER //
// ./src/api/service.js